<div class="usa-accordion" >
    <h4 class="usa-accordion__heading">
        <button class="usa-accordion__button filter-category-button"
                attr.aria-expanded="{{filterCategory.isExpanded}}"
                (click)="expandClick()"
                arrr.aria-controls="foreignList">
            {{title}}
        </button>
    </h4>
    <div id="foreignList" *ngIf="filterCategory.isExpanded" class="usa-accordion__content usa-prose content-max-height">
        <ul class="usa-list usa-list--unstyled">
            <li *ngFor="let filterValue of filterCategory.filterValues" (click)="rowClick(filterValue)" (keydown.enter)="rowClick(filterValue)" tabindex="0" class="facet-item-row">
                <a  class="usa-link">{{filterValue.displayValue}}
                    &nbsp;<span *ngIf="filterValue.isIndividual" class="usa-button--filter-count usa-button" disabled>
                        {{filterValue.count}}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</div>
